/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharekindcheckin3Inputs */

const en_sharekindcheckin3 = /** @type {(inputs: Sharekindcheckin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in`)
};

const de_sharekindcheckin3 = /** @type {(inputs: Sharekindcheckin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in`)
};

/**
* | output |
* | --- |
* | "Check-in" |
*
* @param {Sharekindcheckin3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharekindcheckin3 = /** @type {((inputs?: Sharekindcheckin3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharekindcheckin3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharekindcheckin3(inputs)
	return de_sharekindcheckin3(inputs)
});
export { sharekindcheckin3 as "shareKindCheckIn" }